
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24px",
    "height": "24px",
    "viewBox": "0 0 24 24",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "icon-right-circle"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "icon-right-circle",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "right-circle-fill",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形",
                "fill": "#000000",
                "opacity": "0",
                "x": "0",
                "y": "0",
                "width": "24",
                "height": "24"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M12,1.5 C6.2015625,1.5 1.5,6.2015625 1.5,12 C1.5,17.7984375 6.2015625,22.5 12,22.5 C17.7984375,22.5 22.5,17.7984375 22.5,12 C22.5,6.2015625 17.7984375,1.5 12,1.5 Z",
                "id": "路径",
                "fill": "#F5F7FA"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M15.6257813,12.1523438 L9.86015625,16.3242188 C9.7359375,16.4132813 9.5625,16.3242188 9.5625,16.171875 L9.5625,15.0726563 C9.5625,14.8335938 9.67734375,14.60625 9.871875,14.465625 L13.2796875,12 L9.871875,9.534375 C9.67734375,9.39375 9.5625,9.16875 9.5625,8.92734375 L9.5625,7.828125 C9.5625,7.67578125 9.7359375,7.58671875 9.86015625,7.67578125 L15.6257813,11.8476563 C15.7289063,11.9226563 15.7289063,12.0773438 15.6257813,12.1523438 Z",
                "id": "路径",
                "fill": "#3D7DF5"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  